import { create } from 'zustand'

export const noticeActiveStore = create((set) => ({
  isActive: false,
  setIsActive: (value) => set({ isActive: value })
}))
